/**
 * Cart Bundles Tracking - Client-Side Tier Management
 */

document.addEventListener("DOMContentLoaded", async () => {
  // Hide real discount badges immediately to prevent flash
  const style = document.createElement("style");
  style.textContent = `
    .upcart-discount-code-badge:not(.visual-tier-discount) {
      position: absolute !important;
      top: 0 !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(style);
  // Initialize breaksData - ensure tier_value is a number
  breaksData.forEach((breakData) => {
    breakData.tier_value = parseInt(breakData.tier_value, 10);
  });
  // Sort descending to get highest tier first (4, 3, 2, 1)
  breaksData.sort((a, b) => b.tier_value - a.tier_value);

  // Discount percentages for each tier (only break1 and break2 have discount codes)
  const tierDiscounts = {
    break1: 15,
    break2: 20,
  };

  // Tier labels for display (only break1 and break2 have discount codes)
  const tierLabels = {
    break1: "Buy 1",
    break2: "Buy 2+",
  };

  // Flag to prevent concurrent updates
  let isUpdating = false;

  const checkAndUpdateCart = async () => {
    if (isUpdating) return;
    isUpdating = true;

    try {
      // Fetch cart data
      const timestamp = new Date().getTime();
      const rawHTML = await fetch("/").then((res) => res.text());
      const cart = await fetch(`/cart.js?t=${timestamp}`).then((res) =>
        res.json()
      );

      // Parse items from DOM
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(rawHTML, "text/html");
      const items = JSON.parse(
        htmlDoc.querySelector("#items_in_the_cart")?.value || "[]"
      );

      // Get current tier attributes
      const cartAttributesArray = Object.keys(cart.attributes);
      const currentTierAttributes = cartAttributesArray
        .filter((attributeStr) =>
          breaksData.some(
            (breakData) => breakData.attribute_key == attributeStr
          )
        )
        .map((cartAttribute) => ({
          key: cartAttribute,
          value: cart.attributes[cartAttribute],
        }));

      // If tiers are disabled, clear attributes and exit
      if (!allowTiersAttributes) {
        if (currentTierAttributes.length) {
          await updateCartAttributes(
            currentTierAttributes.map((attr) => ({ key: attr.key, value: "" }))
          );
        }
        return;
      }

      // Calculate qualifying items
      let wholeValues = 0;
      let hasBundleItems = false;
      items?.forEach((item) => {
        if (!item.isExcluded) {
          const quantity = parseInt(item.quantity, 10) || 0;
          const multiplier = parseInt(item.multiplier, 10) || 1;
          wholeValues += quantity * multiplier;
          // Check if this is a bundle item (multiplier > 1), Yogananda product, blue-light-protection-set, or circadian-set
          const productHandle = (item.product_handle || "").toLowerCase();
          if (
            multiplier > 1 ||
            productHandle.includes("yogananda") ||
            productHandle.includes("blue-light-protection-set") ||
            productHandle.includes("circadian-set")
          ) {
            hasBundleItems = true;
          }
        }
      });

      // If cart has any bundle items OR 2+ items, use break2
      // Otherwise use break1 (for 1 item only)
      let selectedBreak;
      if (hasBundleItems || wholeValues >= 2) {
        // Bundle items or 2+ items → break2 (Buy 2+, 20% Off)
        selectedBreak = breaksData.find(
          (breakData) => breakData.attribute_value === "break2"
        );
      } else {
        // 1 item only → break1 (Buy 1, 15% Off)
        selectedBreak = breaksData.find(
          (breakData) => breakData.attribute_value === "break1"
        );
      }

      // Update tier attribute if needed
      if (selectedBreak) {
        // Check if the correct tier is already set
        const isCorrectTier = currentTierAttributes.some(
          (attr) =>
            attr.key == selectedBreak.attribute_key &&
            attr.value == selectedBreak.attribute_value
        );

        if (!isCorrectTier) {
          // Set new tier and clear old ones
          await updateCartAttributes([
            {
              key: selectedBreak.attribute_key,
              value: selectedBreak.attribute_value,
            },
            ...currentTierAttributes.map((attr) => ({
              key: attr.key,
              value: "",
            })),
          ]);
        }
      } else {
        // Clear all tier attributes if no tier qualifies
        if (currentTierAttributes.length) {
          await updateCartAttributes(
            currentTierAttributes.map((attr) => ({ key: attr.key, value: "" }))
          );
        }
      }

      // Replace discount badges with visual ones
      replaceDiscountBadges(selectedBreak, tierDiscounts);
    } catch (error) {
      // Silent error handling
    } finally {
      isUpdating = false;
    }
  };

  const replaceDiscountBadges = (selectedBreak, tierDiscounts) => {
    // First, hide all real discount badges immediately to prevent flash
    const realDiscountBadges = document.querySelectorAll(
      ".upcart-discount-code-badge:not(.visual-tier-discount)"
    );
    realDiscountBadges.forEach((badge) => {
      badge.style.position = "absolute";
      badge.style.top = "0";
      badge.style.display = "none";
    });

    // Remove any existing visual discount badges
    const existingVisualBadges = document.querySelectorAll(
      ".visual-tier-discount"
    );
    existingVisualBadges.forEach((badge) => badge.remove());

    // If no tier selected, just hide the real badges and return
    if (!selectedBreak) {
      return;
    }

    // Only show badges for break1 and break2 (they're the only ones with discount codes)
    if (
      selectedBreak.attribute_value !== "break1" &&
      selectedBreak.attribute_value !== "break2"
    ) {
      return;
    }

    // Get discount percentage
    const discountPercent = tierDiscounts[selectedBreak.attribute_value] || 0;
    if (discountPercent === 0) {
      return;
    }

    // Get tier label
    const tierLabel = tierLabels[selectedBreak.attribute_value] || "";

    // Create discount text in the format: "Buy 1, 15% Off" or "Buy 2+, 20% Off"
    const discountText = tierLabel
      ? `${tierLabel}, ${discountPercent}% Off`
      : `${discountPercent}% Off`;

    // 1. REPLACE PRODUCT DISCOUNT BADGES
    const productRows = document.querySelectorAll(
      ".styles_ProductRow__price__"
    );

    productRows.forEach((productRow) => {
      // Check if a visual badge already exists in this product row
      if (productRow.querySelector(".visual-tier-discount")) {
        return;
      }

      // Create the fake discount badge with the same structure and classes
      const discountBadge = document.createElement("div");
      discountBadge.className =
        "upcart-discount-code-badge DiscountCodeBadge_discountBadge__ visual-tier-discount";

      discountBadge.innerHTML = `
        <div class="upcart-discount-code-icon DiscountCodeBadge_icon__">
          <svg viewBox="0 0 20 20">
            <path d="M13 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
            <path fill-rule="evenodd" d="M11.276 3.5a3.75 3.75 0 0 0-2.701 1.149l-4.254 4.417a2.75 2.75 0 0 0 .036 3.852l2.898 2.898a2.5 2.5 0 0 0 3.502.033l4.747-4.571a3.25 3.25 0 0 0 .996-2.341v-2.187a3.25 3.25 0 0 0-3.25-3.25h-1.974Zm-1.62 2.19a2.25 2.25 0 0 1 1.62-.69h1.974c.966 0 1.75.784 1.75 1.75v2.187c0 .475-.194.93-.536 1.26l-4.747 4.572a1 1 0 0 1-1.401-.014l-2.898-2.898a1.25 1.25 0 0 1-.016-1.75l4.253-4.418Z"></path>
          </svg>
        </div>
        <span class="upcart-discount-code-text DiscountCodeBadge_title__">
          ${discountText}
        </span>
      `;

      // Append the badge directly to the product row container
      productRow.appendChild(discountBadge);
    });

    // 2. REPLACE FOOTER DISCOUNT BADGE
    const footerDiscountContainer = document.querySelector(
      ".styles_Footer__slidingCodes__"
    );

    if (footerDiscountContainer) {
      // Create footer discount badge
      const footerDiscountBadge = document.createElement("div");
      footerDiscountBadge.className =
        "upcart-discount-code-badge DiscountCodeBadge_discountBadge__ visual-tier-discount";

      footerDiscountBadge.innerHTML = `
        <div class="upcart-discount-code-icon DiscountCodeBadge_icon__">
          <svg viewBox="0 0 20 20">
            <path d="M13 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
            <path fill-rule="evenodd" d="M11.276 3.5a3.75 3.75 0 0 0-2.701 1.149l-4.254 4.417a2.75 2.75 0 0 0 .036 3.852l2.898 2.898a2.5 2.5 0 0 0 3.502.033l4.747-4.571a3.25 3.25 0 0 0 .996-2.341v-2.187a3.25 3.25 0 0 0-3.25-3.25h-1.974Zm-1.62 2.19a2.25 2.25 0 0 1 1.62-.69h1.974c.966 0 1.75.784 1.75 1.75v2.187c0 .475-.194.93-.536 1.26l-4.747 4.572a1 1 0 0 1-1.401-.014l-2.898-2.898a1.25 1.25 0 0 1-.016-1.75l4.253-4.418Z"></path>
          </svg>
        </div>
        <span class="upcart-discount-code-text DiscountCodeBadge_title__">
          ${discountText}
        </span>
      `;

      footerDiscountContainer.appendChild(footerDiscountBadge);
    }
  };

  const updateCartAttributes = async (attributes) => {
    if (!attributes || attributes.length === 0) return false;

    const formData = new FormData();
    attributes.forEach((attribute) => {
      formData.append(`attributes[${attribute.key}]`, attribute.value);
    });

    try {
      // Update attributes
      await fetch("/cart/update.js", {
        method: "POST",
        body: formData,
      }).then((res) => res.json());

      return true;
    } catch (err) {
      return false;
    }
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  };

  // Listen for cart changes
  const setupListeners = () => {
    (function (ns, fetch) {
      ns.fetch = async (...args) => {
        const response = fetch.apply(this, args);
        response.then(async (res) => {
          if (
            !isUpdating &&
            res.url.includes("/cart") &&
            !res.url.includes("/cart.js")
          ) {
            checkAndUpdateCart();
          }
        });
        return response;
      };
    })(window, window.fetch);

    // Also listen for DOM mutations to catch dynamically loaded cart items
    const observer = new MutationObserver((mutations) => {
      if (isUpdating) return;

      for (const mutation of mutations) {
        // Check if any cart-related elements were added
        if (mutation.addedNodes.length > 0) {
          const hasCartElements = Array.from(mutation.addedNodes).some(
            (node) => {
              if (node.nodeType !== 1) return false;
              return (
                node.classList?.contains("styles_ProductRow__price__") ||
                node.querySelector?.(".styles_ProductRow__price__") ||
                node.classList?.contains("upcart-item-prices-row") ||
                node.querySelector?.(".upcart-item-prices-row") ||
                node.classList?.contains("styles_Footer__") ||
                node.querySelector?.(".styles_Footer__")
              );
            }
          );

          if (hasCartElements) {
            checkAndUpdateCart();
            break;
          }
        }
      }
    });

    // Observe the entire document body for cart updates
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  // Run initial check
  await new Promise((resolve) => setTimeout(resolve, 300));
  await checkAndUpdateCart();

  // Start listening for cart changes
  if (allowTiersAttributes) {
    setupListeners();
  }
});
